module.exports = __webpack_public_path__ + "static/media/fa-solid-900.7e40a8ea.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/fa-solid-900.woff
// module id = 772
// module chunks = 0